import { requests } from './request2'

// 获取个人信息
export function queryCloseExam(data) {
    return requests({
        url: '/exam/queryCloseExam',
        method: 'post',
        data
    })
}
export function queryExamList(data) {
    return requests({
        url: '/exam/queryExamList',
        method: 'post',
        data
    })
}
//答一道存一道
export function saveTopic(data) {
    return requests({
        url: '/exam/saveTopic',
        method: 'post',
        data
    })
}

//开始答题获取题id
export function startExam(data) {
    return requests({
        url: '/exam/startExam',
        method: 'post',
        data
    })
}

//结束的时候提交
export function endExam(data) {
    return requests({
        url: '/exam/endExam',
        method: 'post',
        data
    })
}

// 判断用户是否是会员
export function verifyUserIsMember({data, trainTime}){
    if(data) {
        return requests ({
            url: `username/verifyUserIsMember?idCard=${data}&trainTime=${trainTime}`,
            method: 'get',
        }).catch(err => err)
    }
    else{
        return requests ({
            url: `username/verifyUserIsMember?trainTime=${trainTime}`,
            method: 'get',
        }).catch(err => err)
    }
}
